import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';

import { all_routes } from '../router/all_routes';
import { AppDispatch, RootState } from '../../core/data/redux/store';
import { passwordChange, resetAuth } from '../../core/data/redux/action';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';

const routes = all_routes;

type FormValues = {
  password: string;
  password_confirmation: string;
};

const ResetPassword = () => {
  const [isToggle, setIsToggle] = useState(false);
  const [isToggle1, setIsToggle1] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : null;
  };

  const { success, error } = useSelector((state: RootState) => ({
    success: state.auth.success,
    error: state.auth.error,
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>({
    defaultValues: {
      password: '',
      password_confirmation: '',
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(
      passwordChange({
        ...data,
        token: getParam('token'),
        email: getParam('email'),
      })
    );
  };

  useEffect(() => {
    if (success) {
      showToast(success);
      dispatch(resetAuth());
      navigate(routes.login);
      reset();
    } else if (error) {
      showToast(error);
    }
  }, [success, error]);

  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  const showToast = (message: any) => {
    setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white');
    setToastMessage(message);
  };

  const handleCloseToast = () => {
    setToastMessage('');
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      } else {
        toast.success(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      }
    }
  }, [toastMessage, toastClass]);

  return (
    <div className="main-wrapper login-body">
      {/* Header */}
      <header className="log-header">
        <Link to={routes.homeOne}>
          <ImageWithBasePath
            className="img-fluid logo-dark"
            src="assets/img/logo/fairRentallogo.png"
            alt="Logo"
          />
        </Link>
      </header>

      {toastMessage && <ToastContainer autoClose={3000} limit={1} />}
      {/* /Header */}
      <div className="login-wrapper">
        <div className="loginbox">
          <div className="login-auth">
            <div className="login-auth-wrap">
              <div className="sign-group">
                <Link
                  to={routes.homeOne}
                  className="border-0 text-primary-dark d-flex align-items-center"
                >
                  <i className="bx bx-arrow-back fs-5 me-2"></i>

                  <span className="mt-1"> Back To Home </span>
                </Link>
              </div>
              <h1>Reset Password</h1>
              {/* <p className="account-subtitle mb-2">
                Your new password must be different from previous used
                passwords.
              </p> */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-block">
                  <label className="form-label">
                    New Password <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isToggle ? 'text' : 'password'}
                      className="form-control pass-input"
                      placeholder=""
                      {...register('password', {
                        required: 'Password is required',
                      })}
                    />
                    <span
                      onClick={() => setIsToggle(!isToggle)}
                      className={`fas toggle-password ${
                        isToggle ? 'fa-eye' : 'fa-eye-slash'
                      }`}
                    />
                    {errors.password && (
                      <p className="text-danger">{errors.password.message}</p>
                    )}
                  </div>
                </div>
                <div className="input-block">
                  <label className="form-label">
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isToggle1 ? 'text' : 'password'}
                      className="form-control pass-input"
                      placeholder=""
                      {...register('password_confirmation', {
                        required: 'Password is required',
                      })}
                    />
                    <span
                      onClick={() => setIsToggle1(!isToggle1)}
                      className={`fas toggle-password ${
                        isToggle1 ? 'fa-eye' : 'fa-eye-slash'
                      }`}
                    />
                    {errors.password_confirmation && (
                      <p className="text-danger">
                        {errors.password_confirmation.message}
                      </p>
                    )}
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 btn-size py-1"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="log-footer">
        <div className="container-fluid">
          <div className="copyright">
            <div className="copyright-text">
              <p>© 2025 FaiRental. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResetPassword;
